import React from "react";
import { Icon, Loader } from "semantic-ui-react";

export default function ActionBtn({
  loading = { loading: false },
  callback,
  label,
  icon = "",
  imgSrc = "",
  imgStyles = {},
  isSecondary = false,
  isDisabled = false,
  isFluid = false,
  isBase = false,
  isInverted = false,
  style = {},
  dataTestId = "",
}) {
  let actionIcon = icon && !label;
  let classList = [];
  classList.push("action");
  isSecondary ? classList.push("secondary") : classList.push("primary");
  if (actionIcon) classList.push("no-label");
  if (isDisabled) classList.push("disabled");
  if (isFluid) classList.push("fluid");
  if (isBase) classList.push("base");
  if (isInverted) classList.push("inverted");

  return (
    <button
      data-test={dataTestId}
      className={classList.join(" ")}
      onClick={callback ? () => callback() : () => null}
      style={style ? { ...style } : {}}
      disabled={isDisabled}
    >
      {loading?.loading && (
        <span className="pre-action">
          <Loader
            inline={true}
            active={true}
            inverted={isSecondary || actionIcon ? false : true}
            size={"mini"}
          />
        </span>
      )}
      <span
        className={`action-label ${loading?.loading ? "invisible" : "visible"}`}
      >
        {icon && (
          <span className="btn-icon">
            <Icon name={icon} />
          </span>
        )}
        {imgSrc && (
          <span className="btn-img">
            <img src={imgSrc} alt={label} style={{ ...imgStyles }} />
          </span>
        )}
        {label && label}
      </span>
    </button>
  );
}
